var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.413 26.414H21.82V19.22c0-1.715-.03-3.923-2.389-3.923-2.392 0-2.758 1.869-2.758 3.799v7.317H12.08V11.621h4.41v2.021h.06a4.832 4.832 0 0 1 4.351-2.389c4.656 0 5.514 3.062 5.514 7.046l-.002 8.115ZM6.897 9.599a2.666 2.666 0 1 1 0-5.331 2.666 2.666 0 0 1 0 5.331Zm2.297 16.815H4.596V11.62h4.597v14.793ZM28.704.002H2.286A2.262 2.262 0 0 0 0 2.237v26.526A2.264 2.264 0 0 0 2.287 31h26.416A2.269 2.269 0 0 0 31 28.763V2.235A2.267 2.267 0 0 0 28.703 0",
    fill: "#0A66C2"
  })));
};

export default SvgLinkedIn;